import { render } from "./DashboardPanelRanking.vue?vue&type=template&id=bad1358e&scoped=true"
import script from "./DashboardPanelRanking.vue?vue&type=script&lang=js"
export * from "./DashboardPanelRanking.vue?vue&type=script&lang=js"

import "./DashboardPanelRanking.vue?vue&type=style&index=0&id=bad1358e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad1358e"]])

export default __exports__